
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import {
  setProductAccount,
  getProductAccount,
} from '@/api/product/productAccount'
import editAccountConfig from './editAccountConfig.vue'
import editAccountLimitation from './editAccountLimitation.vue'
import { Form as ElForm } from 'element-ui'
// import { productAccountBasicRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
import { timeJoin } from '@/utils/dateTime'
import { getAccountGroupList } from '@/api/product/accountGroup'
import { getMerchant } from '@/api/merchant/merchant'
import dedicatedMerchant from './dedicatedMerchant.vue'

@Component({
  name: 'editAccount',
  components: {
    editAccountConfig,
    editAccountLimitation,
    dedicatedMerchant,
  },
})
export default class extends Vue {
  @Prop({ required: true }) product!: any
  @Prop({ required: true }) id!: string | number
  @Prop({ default: true }) isEdit!: boolean
  @Prop({ required: true }) accountList!: any

  private loading: boolean = false
  private extraParamTable: any = {}
  private currentAccount: any = {}
  private status: any = ''
  private infoForm: any = {
    merchant_no: null,
    description: null,
  }
  private productAccountBasicRules: any = {
    account_name: [
      {
        required: true,
        message: 'Please enter the Account Name',
        trigger: 'blur',
      },
    ],
    account_no: [
      {
        required: true,
        message: 'Please enter the Account No',
        trigger: 'blur',
      },
      // { pattern: /^\w+$/, message: 'letters, numbers or underscores', trigger: 'change' }
    ],
    account_type: [
      {
        required: true,
        message: 'Please select Account Type',
        trigger: 'blur',
      },
    ],
    status: [
      { required: true, message: 'Please select status', trigger: 'blur' },
    ],
    description: [
      { required: true, message: 'Please input description', trigger: 'blur' },
    ],
  }

  // private rules = productAccountBasicRules
  // private currentAccountId: any = this.id
  private accountType: any = this.product
  private productAccountList: any = []

  private flag: boolean = false
  // 按钮只触发一次0
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  // 打开专用商户账户
  private openDedicatedAccount: boolean = false
  private openDialog() {
    this.openDedicatedAccount = true
  }

  private closeDedicated() {
    this.openDedicatedAccount = false
  }

  private back() {
    this.$emit('close')
  }

  // 获取账户组列表
  private async getAccountGroupList() {
    const params = {
      product: this.product.id,
    }
    await getAccountGroupList(params).then((res: any) => {
      this.productAccountList = res.results
    })
  }

  // 远程查询
  private async remoteQuery(query: string) {
    const data = {
      name: query,
      product: this.product.id,
    }
    await getAccountGroupList(data).then((res: any) => {
      this.productAccountList = res.results
    })
  }

  private async getProductAccount() {
    await getProductAccount(this.id).then((res: any) => {
      this.currentAccount = res
      this.extraParamTable = res.extra_param
    })
  }

  private allObj = this.$refs.limitation
  private async update() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          let config: any = this.$refs.config
          let limitation: any = this.$refs.limitation
          let times: any[] = []
          let timeStr: any = ''
          limitation.openTimes.forEach((time: any) => {
            if (time[0]) {
              timeStr = timeJoin(time[0], time[1])
              times.push(timeStr)
            }
          })
          let timeData =
            this.product.product_account_param[this.currentAccount.account_type]
          timeData.map((item) => {
            if (item.type === 'duration') {
              config.form[item.field] === ''
                ? (config.form[item.field] = ['00:00-23:59'])
                : config.form[item.field]
            }
          })
          const data: any = {
            ...this.currentAccount,
            // api_key 做为数组
            extra_param: { ...config.form, api_key: config.apiKey },
            status: this.status||this.currentAccount.status,
            open_time: times,
            daily_limited_volume: limitation.form.daily_limited_volume
              ? limitation.form.daily_limited_volume
              : 0,
            daily_limited_transaction: limitation.form.daily_limited_transaction
              ? limitation.form.daily_limited_transaction
              : 0,
            min_amount: limitation.form.min_amount
              ? limitation.form.min_amount
              : 0,
            max_amount: limitation.form.max_amount
              ? limitation.form.max_amount
              : 0,
            hook_info: {
              choice_product_account_config: {
                status:
                  limitation.form.hook_info.choice_product_account_config
                    .status,
                frequency:
                  limitation.form.hook_info.choice_product_account_config
                    .frequency,
              },
            }
          }
          // delObjEmptyKey(data)
          if (!data.open_time) {
            data.open_time = ['00:00-23:59']
          }
          await setProductAccount(data).then((res: any) => {
            this.$message({
              message: 'Save successful!',
              type: 'success',
            })
            this.currentAccount = res
            this.loading = false
            this.flagStr()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  private getQuestion() {
    let config =
      this.product.product_account_param[this.currentAccount.account_type]
    if (config === undefined) return false
    return config.some((c) => {
      if (c.help && c.help !== null && c.help !== undefined) return true
    })
  }

  mounted() {
    this.getProductAccount()
    this.getAccountGroupList()
  }
}
